import styled, { css } from "styled-components";

export const MainDiv = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: #646765;
`;

/* ✅ SOLD бейдж */
export const SoldLabel = styled.div`
  position: absolute;
  top: 110px;
  left: 22px;
  z-index: 50;
  padding: ${(p) => (p.$small ? "8px 12px" : "10px 14px")};
  border-radius: 999px;
  font-weight: 900;
  letter-spacing: 1px;
  color: #fff;
  background: rgba(180, 40, 40, 0.92);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.25);
  pointer-events: none;
  font-size: ${(p) => (p.$small ? "14px" : "16px")};

  @media (max-width: 480px) {
    top: 12px;
    left: 12px;
    padding: ${(p) => (p.$small ? "7px 10px" : "8px 12px")};
    font-size: ${(p) => (p.$small ? "13px" : "14px")};
  }
`;

export const GlavniImg = styled.div`
  width: 100%;
  background-color: #646765;
  padding-top: 70px;
  min-height: 100vh;
  position: relative; /* ✅ чтобы SoldLabel позиционировался поверх */

  img {
    width: 100%;
    height: 100vh;
    object-fit: contain;
  }


`;

export const DetailsDiv = styled.div`
  width: 45%;
  margin: 100px auto;
  text-align: center;

  span {
    font-family: "Lato", sans-serif;
    color: white;
    font-size: 45px;
    font-weight: 300;
  }
  @media (max-width: 1200px) {
    width: 60%;
  }
  @media (max-width: 800px) {
    width: 70%;
  }
  @media (max-width: 600px) {
    width: 80%;
  }
  @media (max-width: 400px) {
    width: 90%;
  }
`;

export const ImgDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative; /* ✅ для SoldLabel */

  img {
    width: 70%;
    border-radius: 20px;
    object-fit: cover;
    margin-top: 50px;
  }


`;

export const ArrowsDiv = styled.div`
  width: 50px;
  height: 407px;
  padding-top: 200px;
  cursor: pointer;
`;

export const HorizonDiv = styled.div`
  width: 20%;
  margin: 0 auto;
  margin-top: 100px;
  text-align: center;
  position: relative; /* ✅ для SoldLabel */

  span {
    font-family: "Lato", sans-serif;
    color: white;
    font-size: 30px;
    font-weight: 300;
  }
  img {
    width: 100%;
    border-radius: 20px;
    object-fit: cover;
    margin-top: 50px;
  }
  @media (max-width: 800px) {
    width: 40%;
  }

  ${(p) =>
    p.$sold &&
    css`
      img {
        filter: grayscale(1) brightness(80%) contrast(1.05);
      }
    `}
`;

export const InfoDiv = styled.div`
  width: 60%;
  margin: 0 auto;
  color: white;
  margin-top: 40px;
  text-align: center;
  line-height: 40px;
  font-family: Raleway, sans-serif;
  padding-bottom: 30px;
`;
